
  export const AVAILABLECLASSS_RECEIVED = "AVAILABLECLASSS_RECEIVED";
  export const SET_AVAILABLECLASS = "SET_AVAILABLECLASS";
  export const CREATE_AVAILABLECLASS = "CREATE_AVAILABLECLASS";
  export const SET_PROPERTY_AVAILABLECLASS = "SET_PROPERTY_AVAILABLECLASS";
  